import { render, staticRenderFns } from "./PrefixSetting.vue?vue&type=template&id=edb4a9be&"
import script from "./PrefixSetting.vue?vue&type=script&lang=js&"
export * from "./PrefixSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports